export default function removeMenuActive() {
  $('.tools-list span').on('click', function () {
    $('#wrapper').removeAttr('style');
    $('body').removeClass('menu-active').removeAttr('style');
    $('.menu-btn').removeClass('active');
  });
}